module.exports = __webpack_public_path__ + "img/淡竹叶.3fb1c7ac.jpg";